<div class="chart-loader-container">
  <div class="d-flex flex-column">
    <h3 class="h3-bold primary-100">{{ headingTitle }}</h3>
    <h4 *ngIf="subtitle" class="h4-reg primary-60">{{ subtitle }}</h4>
  </div>
  <!-- Loading State -->
  @if (resource.isLoading()) {
    <div class="state-overlay loading-overlay" aria-live="polite">
      <div class="loader-container">
        <img [src]="loaderImagePath" alt="Loading data" class="loader-spin" />
        <span class="loading-text">Loading data</span>
      </div>
    </div>
  }

  <!-- Error State -->
  @if (resource.error() && !resource.isLoading()) {
    <div class="state-overlay error-overlay" aria-live="assertive">
      <div class="chart-error" role="alert">
        <div class="d-flex flex-column spacing-4 error-content">
          @if (getErrorMessage().title) {
            <div class="error-title h4-bold">{{ getErrorMessage().title }}</div>
          }
          <div class="error-hint h4-reg">
            {{ getErrorMessage().message }}
          </div>
        </div>
        <app-secondary-btns
          class="retry-btn"
          (onClick)="resource.reload()"
          label="Retry"
          size="small"
          IconType=""></app-secondary-btns>
      </div>
    </div>
  }

  <!-- Empty State -->
  @if (!resource.isLoading() && !resource.error() && !resource.hasValue()) {
    <div class="state-overlay empty-overlay" aria-live="polite">
      <div class="chart-empty">
        <div class="empty-message">{{ emptyMessage }}</div>
      </div>
    </div>
  }

  <!-- Content -->
  <div class="chart-content" [class.dimmed]="!resource.hasValue()">
    @if (resource.hasValue() && contentTemplate) {
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    }
  </div>
</div>
